import React from "react";
import type { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import type { IconDefinition } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const useStyles = makeStyles((theme: Theme) => ({
    label: {
        display: "inline-block",
    },
    startIcon: {
        display: "inherit",
        marginRight: theme.spacing(0.5),
    },
    endIcon: {
        display: "inherit",
        marginLeft: theme.spacing(0.5),
    },
}));

type IconLabelProps = {
    children?: React.ReactNode;
    endIcon?: IconDefinition;
    startIcon?: IconDefinition;
};
export const IconLabel = (props: IconLabelProps) => {
    const classes = useStyles();
    return (
        <span className={classes.label}>
            {props.startIcon && (
                <span className={classes.startIcon}>
                    <FontAwesomeIcon icon={props.startIcon} fixedWidth />
                </span>
            )}
            {props.children}
            {props.endIcon && (
                <span className={classes.endIcon}>
                    <FontAwesomeIcon icon={props.endIcon} fixedWidth />
                </span>
            )}
        </span>
    );
};
